
function customScript() {
    const targetSelector = '.aw-col-4';
    const elementToMoveSelector = '#myTopnav';
    const intervalId = setInterval(() => {
        const navElement = document.querySelector('#myTopnav');
        const target = document.querySelector(targetSelector);
        const elementToMove = document.querySelector(elementToMoveSelector);

        if (navElement && target && elementToMove) {
            target.prepend(elementToMove);
            clearInterval(intervalId);
            appendText();
        }
    }, 100);
}

function appendText() {
    const ele = document.querySelector('.aw-col-4');
    const text = document.createElement('h1');
    text.textContent = "Danh sách cửa hàng";
    text.classList.add('aw-custom-text');
    ele.prepend(text);
    activeAllInput();
}

function activeAllInput() {
    const intervalId = setInterval(() => {
        const el = document.querySelector(`#tag_0`);
        if (el) {
            el.checked = true;
            clearInterval(intervalId);
        }
    }, 100);
}
document.addEventListener('DOMContentLoaded', () => {
    const targetpath = '/pages/cua-hang'
    const path = window.location.pathname;
    if (path === targetpath) {
        customScript();
    }
});